export const queryTableData = async (queryList, payload) => {
  try {
    return await queryList(payload);
  } catch (error) {
    console.log("error: ", error);
    return null;
  }
};
